/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';

export default class BannerSkeleton extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		return (
			<div className="HomeFacadeBlock BannerSkeleton">
				<div className="HomeFacadeBlock-header">
					<h2 />
				</div>
				<div className="HomeFacadeBlock-body" />
			</div>
		);
	}
}
